import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext.jsx";

const PASSWORD_HINT = "At least 12 characters, with uppercase, lowercase, a number, and a symbol.";

export default function Login() {
  const { session, login, error, newPasswordChallenge, completeNewPassword, cancelNewPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [localError, setLocalError] = useState(null);

  if (session) return <Navigate to="/" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    await login(email, password);
    setSubmitting(false);
  };

  const onSetNewPassword = async (e) => {
    e.preventDefault();
    setLocalError(null);
    if (newPassword !== confirmPassword) {
      setLocalError("Passwords do not match.");
      return;
    }
    if (newPassword.length < 12) {
      setLocalError("Password must be at least 12 characters.");
      return;
    }
    setSubmitting(true);
    const ok = await completeNewPassword(newPassword);
    setSubmitting(false);
    if (ok) {
      setNewPassword("");
      setConfirmPassword("");
    }
  };

  const onBackToSignIn = () => {
    cancelNewPassword();
    setPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setLocalError(null);
  };

  if (newPasswordChallenge) {
    return (
      <div className="login-shell">
        <form className="login-card" onSubmit={onSetNewPassword}>
          <h2>Set a new password</h2>
          <p className="login-subtitle">
            This is your first sign-in — choose a permanent password to replace the temporary one Cognito emailed you.
          </p>
          <div className="field">
            <label htmlFor="new-password">New password</label>
            <input
              id="new-password"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              minLength={12}
              autoFocus
              autoComplete="new-password"
              required
            />
          </div>
          <div className="field">
            <label htmlFor="confirm-password">Confirm new password</label>
            <input
              id="confirm-password"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              minLength={12}
              autoComplete="new-password"
              required
            />
          </div>
          <p className="field-hint">{PASSWORD_HINT}</p>
          {(localError || error) && <div className="error-banner">{localError || error}</div>}
          <button className="primary" type="submit" disabled={submitting} style={{ width: "100%" }}>
            {submitting ? "Setting password…" : "Set password & sign in"}
          </button>
          <button type="button" className="link" onClick={onBackToSignIn} style={{ width: "100%", marginTop: 14, textAlign: "center" }}>
            Back to sign in
          </button>
        </form>
      </div>
    );
  }

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={onSubmit}>
        <h2>AWS Billing Dashboard</h2>
        <p className="login-subtitle">bizmoto.com.ph accounting audit &amp; monitoring</p>
        <div className="field">
          <label htmlFor="email">Email</label>
          <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div className="field">
          <label htmlFor="password">Password</label>
          <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        {error && <div className="error-banner">{error}</div>}
        <button className="primary" type="submit" disabled={submitting} style={{ width: "100%" }}>
          {submitting ? "Signing in…" : "Sign in"}
        </button>
        <p className="field-hint" style={{ margin: "16px 0 0" }}>
          Accounts are provisioned by an admin via Cognito — there is no self-signup.
        </p>
      </form>
    </div>
  );
}
